/**
 * CRM Multi-Compagnia · Vista Scadenze (rate / installments)
 */
import { useState } from "react";
import { CalendarClock, Send } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, Btn, Select, StatusBadge,
  toast, fmtDate, fmtEUR
} from "@/components/crm-multi/shared";

export default function CrmMultiScadenzePage() {
  const [stato, setStato] = useState("da_incassare");
  const list = useApi(() => api.get("/installments", { stato: stato || undefined, limit: 200 }), [stato]);

  const sendReminder = (id) => toast("Spoki reminder inviato (MOCK — integrazione Fase 5)", "info");

  return (
    <div className="space-y-4" data-testid="cm-scadenze-page">
      <header className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-zinc-900 flex items-center gap-2"><CalendarClock className="w-5 h-5" /> Scadenze rate</h2>
          <p className="text-sm text-zinc-500">{list.data?.total ?? 0} rate</p>
        </div>
        <Select value={stato} onChange={(e) => setStato(e.target.value)} className="md:w-56">
          <option value="">Tutti gli stati</option>
          <option value="da_incassare">Da incassare</option>
          <option value="incassata">Incassate</option>
          <option value="insoluta">Insolute</option>
        </Select>
      </header>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="cm-scadenze-table"
          columns={[
            { key: "data_scadenza", label: "Scadenza", render: r => fmtDate(r.data_scadenza) },
            { key: "policy_id", label: "Polizza", render: r => <code className="text-xs">{r.policy_id?.slice(0, 8)}</code> },
            { key: "numero_rata", label: "#", render: r => `Rata ${r.numero_rata}` },
            { key: "importo_eur", label: "Importo", render: r => <span className="font-mono text-xs">{fmtEUR(r.importo_eur)}</span> },
            { key: "stato", label: "Stato", render: r => <StatusBadge tipo="incasso" valore={r.stato} /> },
            { key: "azioni", label: "", render: r => r.stato === "da_incassare" && (
              <Btn variant="ghost" size="sm" onClick={() => sendReminder(r.id)} data-testid={`cm-scadenze-reminder-${r.id}`}>
                <Send className="w-3.5 h-3.5" /> Reminder
              </Btn>
            )},
          ]}
          rows={list.data?.items || []}
          emptyTitle="Nessuna rata"
          emptyHint="Le rate vengono create automaticamente alla creazione di una polizza."
        />
      )}
    </div>
  );
}
